<div class="full-page w-100 px-0 h-100" [style.backgroundImage]="'url(' + ('login/login-banner.jpg' | contentAssetImage) + ')'">
  <div class="login-container h-100">
    <div class="login-details text-center rounded">
      <img class="logo" [src]="'login/maintenance.png' | contentAssetImage" draggable="false" />

      <p class="maintenace-text font-size-14 mt-4" [innerHTML]="'maintenance.page.text' | translate | markdownTranslate"></p>
    </div>
  </div>
</div>
